export default {
  Andpenalties: 'Vertragsstrafen und Vertragsstrafen',
  DeliveryFailed:
    'Die Lieferung ist fehlgeschlagen. Die Rückerstattung erfolgt zu Lasten von Partei A',
  abandonedRequests: 'Verlassener Orden',
  abandonedorder: 'Verlassener Orden',
  accesshelpcenter: 'Greifen Sie auf unser Hilfecenter zu',
  accessoriesLessDelivery:
    'Fehlendes Zubehör, weniger Lieferung, Rückerstattungen gehen zu Lasten von Partei A',
  accesstoken: 'Zugriffstoken',
  accessurlexample: 'Beispiel: your-store.com',
  accessurlprefix:
    'Die URL darf die folgenden Werte nicht enthalten: www., https://, http://, /',
  actions: 'Aktionen',
  activate: 'aktivieren',
  activateStore:
    'Wenn Sie unseren Online-Shop nutzen möchten, aktivieren Sie ihn, um alle DNS-Einträge freizugeben.',
  active: 'AKTIV',
  active2: 'Aktiv',
  actuallyPrice: 'Eigentlich Preis',
  addDomainTips1: 'Verknüpfen Sie eine Domain, die Ihnen bereits gehört.',
  addDomainTips2:
    'Sie können auch eine Subdomain verknüpfen. Bitte stellen Sie sicher, dass Sie Ihr Formular mit „Bezahlen“ oder „Pago“ beginnen. Ex.:',
  addDomainTips3: 'Nicht verwenden',
  addDomainTips4: 'Pass auf! Damit Ihre Domain funktioniert,',
  addDomainTips5: 'Sie müssen einen Hosting-Dienst erwerben und einrichten',
  addDomainTips6: 'oder ein anderes.',
  addDomainTips7: 'Bei Fragen wenden Sie sich bitte an unsere',
  addPopup: 'Gutschein hinzufügen',
  addastore: 'Fügen Sie einen Shop hinzu',
  addstore: 'Store hinzufügen',
  afterEachSuccessful:
    'Nach jeder erfolgreichen Transaktion von Partei B wird Partei A 5 % des erfolgreichen Transaktionsbetrags von Partei B abheben und die revolvierende Marge auf dem Konto von Partei A behalten, während sie sie an Partei B überweist. Die revolvierende Marge auf dem Konto von Partei A für jede Transaktion wird 45 Tage lang aufbewahrt und der Betrag wird nach 45 Tagen an Partei B freigegeben.',
  afterSales:
    'Dies ist die After-Sales-Mailbox. Kunden senden After-Sales-Fragen an diese Mailbox und das After-Sales-Team wird antworten.',
  afterVerification:
    'Wenn der Rückerstattungsgrund nach der Überprüfung unter die folgenden fünf Situationen fällt, wird die Rückerstattung von Partei B getragen',
  agreetoNY: '„Mit der Erstellung eines Kontos stimmen Sie Wiios zu“',
  alreadyhaveanaccount: 'Sie haben bereits ein Konto?',
  and: 'Und',
  apikey: 'API-Schlüssel/Client-ID',
  apisecretkey: 'Geheimer API-Schlüssel/Geheimnis',
  ativo: 'AKTIV',
  backgroundColor: 'Hintergrundfarbe',
  basicinformation: 'Grundlegende Informationen',
  blacklisted:
    'Wenn der Kunde auf die schwarze Liste gesetzt wird, wird die Rückerstattung storniert und von Partei B getragen',
  blacklistedCustomer:
    'Kunde auf der schwarzen Liste, Rückerstattung stornieren',
  borneByParty:
    'Da Partei B nicht rechtzeitig zahlt, beantragt der Kunde die Stornierung der Bestellung und die Rückerstattung geht zu Lasten von Partei B',
  borneParty:
    'Wenn das Produkt nicht zufriedenstellend ist (nicht gefällt), geht die Rückerstattung zu Lasten von Partei A',
  buttonText: 'Schaltflächentext',
  cancel: 'stornieren',
  cancellationAnd:
    'Wenn die Bestellung nicht versandt wird und der Kunde eine Stornierung und Rückerstattung verlangt, geht die Rückerstattung zu Lasten von Partei B',
  cardPaymentsAnswer:
    'Sobald der Kunde auf unserem Konto einzahlt, wird der Betrag am nächsten Tag auf Ihr Wallet überwiesen.',
  cardPaymentsTitile:
    'Wie lange dauert es, bis der Betrag nach der Bestellung durch den Kunden auf mein Konto überwiesen wird?',
  carddesc: 'KARTEN, BOLETO, BANKEINZAHLUNG UND PIX',
  changeAddress:
    'Bei Adressänderungswünschen nach dem Versand der Ware geht die Rückerstattung zu Lasten von Partei B',
  classic: 'Klassiker',
  collaboratorRequestCode:
    'Speichern Sie die Berechtigungen und Codes von Mitarbeitern. (Unsere E-Mail-Adresse lautet _email_, bitte bearbeiten Sie die Berechtigung.)',
  collapsemenu: 'Menü einklappen',
  confirm: 'Bestätigen',
  confirmedAndThe:
    'Wenn die Bestellung bestätigt werden soll und der Kunde länger als 2 Tage nicht antwortet, geht die Rückerstattung zu Lasten von Partei B',
  confirmpassword: 'Bestätigen Sie Ihr Passwort',
  contentTerms: 'Inhaltsbedingungen',
  convertedOrderPaid: 'Konvertierte Bestellung (bezahlt)',
  convertedOrderUnpaid: 'Umgewandelte Bestellung (unbezahlt)',
  copy: 'Kopie',
  correspondingPenalties:
    'Partei B muss Gesetze und Vorschriften sowie Partei A und die Risikomanagementanforderungen der Kartenorganisation für illegale Transaktionen einhalten. Verstößt Partei B gegen eine dieser Regelungen, drohen für Partei B entsprechende Strafen und Bußgelder.',
  countdownImage: 'Countdown-Bild',
  countdownTimer: 'Countdown-Timer',
  countdownBg: 'Countdown-Hintergrundfarbe',
  countdownTextColor: 'Countdown-Textfarbe',
  country: 'Land',
  coupon: 'Coupon',
  couponCode: 'Rabattcode (optional)',
  creatanaccount: 'Ein Konto erstellen',
  createTime: 'Zeit schaffen',
  createaccounttitle:
    'Erstellen Sie Ihr kostenloses Konto mit unserem Basic-Plan, ohne monatliche Gebühren.',
  createfreeaccount: 'Kostenloses Konto erstellen',
  createpassword: 'Erstellen Sie ein Passwort',
  currencyConversionAnswer:
    'Konvertieren Sie basierend auf dem offiziellen Wechselkurs des Zahlungsanbieters',
  currencyConversionTitle: 'Probleme mit der Währungsumrechnung?',
  currentStoreName: 'Aktueller Shop:',
  customerBuysMore:
    'Wenn der Kunde mehr kauft und stornieren und erstatten möchte, geht die Rückerstattung zu Lasten von Partei B',
  date: 'Datum',
  days: 'Tage',
  defaultDomainTips:
    '„Dies ist die kostenlose Domain, die von Wiio bereitgestellt wird. Sie wird immer funktionieren. Wir empfehlen Ihnen jedoch, eine eigene Domain einzurichten.“',
  delete: 'Löschen',
  deleteSelected: 'AUSGEWÄHLTE LÖSCHEN',
  deleteSuccess: 'Löschung erfolgreich!',
  deletedSuccessfully: 'Erfolgreich gelöscht',
  deliveryTime:
    'Der Kunde erhält die Ware, die Lieferzeit ist zu lang, die Ladenfrist wird überschritten, Rückerstattungen werden von Partei A getragen',
  disable: 'Deaktivieren',
  disabledSuccessfully: 'Erfolgreich deaktiviert',
  discount: 'Rabatt',
  discountAmount: 'Rabattbetrag',
  discountPercent: 'Rabattprozentsatz',
  discountRate: 'Rabatteinstellungen',
  dnsNormal: 'Die Konfiguration des DNS-Eintrags ist normal',
  dnsNotConfigured: 'DNS-Eintrag nicht konfiguriert oder nicht weitergegeben.',
  dnsRecordsTitle: 'DNS-Einträge für Ihren Online-Shop',
  domain: 'Domain',
  domainbtntext: 'Aufstellen',
  domaintitle: 'Richten Sie hier dieselbe Domain wie Ihren Shopify-Shop ein.',
  eachSuccessfulTransaction:
    'Nach jeder erfolgreichen Transaktion von Partei B wird Partei A 10 % des erfolgreichen Transaktionsbetrags von Partei B abheben und die revolvierende Marge auf dem Konto von Partei A behalten, während sie sie an Partei B überweist. Die revolvierende Marge auf dem Konto von Partei A für jede Transaktion wird 45 Tage lang aufbewahrt und der Betrag wird nach 90 Tagen an Partei B freigegeben.',
  edit: 'Bearbeiten',
  editstore: 'Shop bearbeiten',
  email: 'E-Mail',
  emailContent: 'E-Mail-Inhalt',
  emailReminders: 'Werbeeinstellung',
  emailRemindersDesc:
    'Richten Sie E-Mail-Erinnerungen ein und bestellen Sie Rabatte',
  emailTemplateConfig: 'Konfiguration der E-Mail-Vorlage',
  emailTemplateConfigDesc: 'Benutzerdefinierter E-Mail-Inhalt',
  emailTitle: 'E-Mail-Betreff',
  embedPaymentMethods:
    'Nutzen Sie E-Mails, um Kunden dazu aufzufordern, die Zahlung zu unterschiedlichen Zeitpunkten abzuschließen, um die Conversion-Rate bei Bestellungen zu erhöhen.',
  emptyCouponDesc:
    'Nach der Konfiguration des Gutscheins erscheint nach Abschluss der Zahlung ein Popup-Fenster zur Einlösung des Gutscheins, das den Benutzer dazu auffordert, den Gutschein für ein günstigeres Angebot zu nutzen.',
  emptyCouponTitle: 'Konfigurieren Sie Ihren Coupon',
  enable: 'Aktivieren',
  enableCouponTips:
    'Es kann jeweils nur ein Coupon aktiv sein. Bitte deaktivieren Sie andere Gutscheine, bevor Sie fortfahren!',
  enabledSuccessfully: 'Erfolgreich aktiviert',
  end: 'Ende',
  endDate: 'Enddatum',
  enter: 'Eingeben',
  entercorrectemail: 'Bitte geben Sie das richtige E-Mail-Format ein',
  enteremailandpassword: 'Geben Sie Ihre E-Mail-Adresse und Ihr Passwort ein',
  example: 'Beispiel',
  faqs: 'FAQs',
  firstPaymentChannel: 'Zahlungsmethode für die erste Bestellung',
  firsttimeaNY: 'Zum ersten Mal bei Wiio?',
  followInstructions: 'Befolgen Sie die Anweisungen',
  followingPenalties:
    'Zusätzlich zu den oben genannten Bußgeldern drohen bei schwerwiegenden Verstößen gegen die Vorschriften folgende Strafen:',
  forBrazil: 'Für Brasilien:',
  forMexico: 'Für Mexiko/Chile/Kolumbien/Peru:',
  forPaymentFailure:
    'Bei Zahlungsausfall geht die Rückerstattung zu Lasten von Partei B',
  forShopify:
    'Wenn Sie sich bei Shopify anmelden, erhält Ihr Online-Shop die URL „myshopify.com“.',
  forgetpassword: 'Ich habe mein Passwort vergessen',
  fullname: 'Vollständiger Name',
  goodsNum: 'Artikel',
  gtm: 'Code (GTM-XXXXXXX)',
  gtmRequired: 'Container-ID ist erforderlich',
  gtmDomain: 'Server-Container-URL',
  gtmDomainRequired: 'Die Server-Container-URL ist erforderlich',
  googleid: 'Mess-ID',
  googlekey: 'Geheimnisse der Measurement Protocol API',
  googleidRequired: 'Mess-ID ist erforderlich',
  googlekeyRequired:
    'Es sind Geheimnisse der Measurement Protocol API erforderlich',
  hasBeenSigned:
    'Aus der Logistik geht hervor, dass es unterzeichnet wurde, der Kunde es jedoch nicht erhalten hat. Die Rückerstattung erfolgt zu Lasten von Partei A',
  hasquestions: 'Haben Sie Fragen?',
  headerImage: 'Header-Bild',
  helpCenter: 'Hilfecenter',
  helpaddress: 'bento.me/enchentesrs',
  hi: 'Hallo',
  holding: '1、Halten',
  home: 'Heim',
  howtocontribute: 'Sehen Sie, wie Sie einen Beitrag leisten können',
  howtoset: 'So stellen Sie ein',
  identifyyourself: 'Identifizieren Sie sich',
  imitationBrand: 'Nachahmung/Imitationsmarke',
  inActive: 'INAKTIV',
  inativo: 'INATIVO',
  info: 'Information',
  installtitle:
    'Installieren Sie Wiio Transparent Checkout in Ihrem Shopify-Shop.',
  invitationNumber: 'Einladungscode',
  invitationNumberError:
    'Bitte geben Sie Ihre Einladungsnummer ein, um Ihre Registrierung abzuschließen',
  isConfirmDelete: 'Möchten Sie es wirklich löschen?',
  kEmail: 'E-Mail',
  kName: 'Name',
  learnMore: 'Erfahren Sie mehr.',
  lengthLimit: 'Die Länge sollte 3 bis 8 betragen',
  letteringPattern:
    'Produktqualität (Größe, Farbunterschied, Beschädigung, Flecken, Fadenenden, Geruch, Falten, Ausbleichen, Schrumpfung, Schriftzug, Muster, Logo, Zubehör), Rückerstattungen werden von Partei A getragen',
  like: 'wie',
  linkNewDomain: 'Neue Domain verknüpfen',
  liquidatedDamages: 'Vertragsstrafen und Vertragsstrafen.',
  logaccount: 'Sie sind angemeldet bei:',
  loginsuccess: 'Anmeldung erfolgreich!',
  logout: 'Abmelden',
  logoutSYS: 'Soll ich mich vom System abmelden?',
  lougoutsuccess: 'Abmeldeerfolg!',
  markAsActive: 'Als aktiv markieren',
  markAsInactive: 'Als inaktiv markieren',
  min: 'min',
  mydomain: 'Meine Domäne',
  mydomains: 'Meine Domains',
  mydomainsdesc:
    'Verwalten Sie hier Ihre Domains. Verknüpfen Sie Ihre Domains und konfigurieren Sie sie als virtuelle Adresse Ihres Shops und Ihrer Kasse.',
  name: 'NAME:',
  needhelp: 'Rio Grande do Sul braucht Ihre Hilfe.',
  newaffiliations: 'Neues Land',
  newpixel: 'Neues Pixel',
  nextPage: 'Nächste Seite',
  backToMessages: 'Zurück zu Nachrichten',
  loadFailed: 'Laden fehlgeschlagen',
  messageDetail: 'Nachrichtendetails',
  noNotifications: 'Keine Benachrichtigungen',
  notifications: 'Benachrichtigungen',
  refresh: 'Aktualisieren',
  readMessage: 'Gelesen',
  unreadMessage: 'Ungelesen',
  no: 'NEIN',
  noDomain: 'Keine Domäne',
  noStatus: 'Kein Status',
  noUseDefaultDomain: 'Verwenden Sie nicht die Wiio-Standard-Bezahldomäne!',
  noUseOrgin: 'Verwenden Sie nicht http:// https:// und www',
  nocountriesavailable: 'Keine Länder verfügbar',
  nodatareadtitle: 'Lesen Sie unseren vollständigen Artikel',
  nodatastartsell:
    'Wenn Sie mit dem Verkauf beginnen, werden Ihre Bestellungen hier angezeigt.',
  nodatatip1:
    'Passen Sie Ihren Shop an das Erscheinungsbild Ihres Unternehmens an!',
  nodatatip2: 'Bieten Sie verschiedene Zahlungsmethoden an.',
  nodatatip3: 'Fügen Sie Ihren Produkten gute Fotos hinzu.',
  nodatatip4:
    'Gestalten Sie Ihre Produktbeschreibungen attraktiv und nutzen Sie SEO-Techniken.',
  nodatatip5:
    'Investieren Sie in bezahlten Traffic: Anzeigen in sozialen Netzwerken und Google Shopping.',
  nodatatip6: 'Prüfen Sie, ob der Preis Ihrer Produkte attraktiv ist.',
  nodatatip7:
    'Verfügen Sie über einen Kundendienstkanal, um Fragen zu beantworten',
  nodatatips: '7 schnelle Tipps für Ihren ersten Verkauf:',
  nodatatitle: 'Es sind noch keine Bestellungen vorhanden',
  nodeDescription: 'Beschreibung der auslösenden Situation',
  nodeName: 'Auslösende Situation',
  operation: 'Status',
  order: 'Befehl',
  orderCancel: 'Abgesagt',
  orderClosed: 'Geschlossen',
  orderConversion: 'Bestellstatus',
  orderConversionTipUnpaid:
    'Durch Remarketing zurückgewonnen, aber noch nicht bezahlt.',
  orderConversionTipUnconverted: 'Vom Kunden nie bezahlt.',
  orderConversionTipPaid:
    'Durch Remarketing zurückgewonnen und erfolgreich bezahlt.',
  orderConversionTipPending:
    'Der Kunde hat den Zahlungsvorgang gestartet, aber nicht abgeschlossen.',
  orderConversionTipPaidStatus: 'Zahlung erfolgreich abgeschlossen.',
  orderDeliver: 'Liefern',
  orderEnd: 'Vollendet',
  orderPaid: 'Bezahlt',
  orderReceived: 'Geliefert',
  orderToAnalyze:
    'Um die Quellen verschiedener Bestellungen zu analysieren und die Werbeanzeigen rechtzeitig anzupassen, sind unsere Daten genauer als die auf Facebook.',
  orderWaitPay: 'Ausstehend',
  ordernum: 'Bestell-Nr',
  more: 'Mehr',
  orderCodesBatchTip:
    'Geben Sie eine Bestell-Nr. pro Zeile ein, oder trennen Sie sie durch Kommas',
  ordertime: 'Bestellzeit',
  originurl: 'Website-Adresse',
  originurlexample: 'Beispiel: your-store.myshopify.com',
  originurlprefix:
    'Die URL darf die folgenden Werte nicht enthalten: www., https://, http://, /, .br',
  package:
    'Wenn der Kunde die Annahme des Pakets verweigert und eine Rückerstattung verlangt, geht die Rückerstattung zu Lasten von Partei B',
  partyAProvides:
    'Partei A bietet einen Rückerstattungsgarantieservice für Kooperationsbestellungen gegen eine Gebühr von 1,5 % an. Wenn sich herausstellt, dass der Rückerstattungsgrund darin besteht, dass der Kunde mit dem Produkt nach Erhalt unzufrieden ist, wird die Rückerstattungsgebühr von Partei A getragen und Partei B muss die damit verbundenen Verluste nicht tragen. Konkrete Nutzungsszenarien entnehmen Sie bitte dem Anhang der Systemvereinbarung.',
  partyAProvidesconsumers:
    'Um die Zahlungsstabilität und Compliance zu gewährleisten, ist Partei A der einzige Anbieter von Kundendiensten für Partei B. Partei B ermächtigt Partei A vollständig, alle Kundendienstangelegenheiten abzuwickeln und Zugriff auf die entsprechenden E-Mail-Konten zu gewähren. Jeglicher Kundendienst durch Partei B ist eine Ausnahme und bedarf der vorherigen Zustimmung von Partei A. In solchen Fällen gewährt Partei B Partei A vollen Zugriff auf die entsprechenden Kundendienst-E-Mail-Konten zur Echtzeitüberwachung. Ein Verstoß gegen diese Klausel berechtigt Partei A, den Zugang von B zu Zahlungsdiensten ohne Haftung sofort auszusetzen oder zu beenden.',
  partyProvides:
    'Partei A bietet Partei B grenzüberschreitende Internet-Zahlungs- und Abwicklungsdienste an, darunter:',
  password: 'Passwort',
  payBy: 'ZAHLEN SIE DURCH',
  payment: 'Zahlung',
  paymentDateAnswer:
    'Sie können den Widerruf nach Zahlung der Auftragserfüllungsgebühr beantragen. Die Auszahlung wird in der Regel innerhalb von 1-2 Werktagen bearbeitet. Die endgültige Ankunftszeit hängt von Ihrer Bank ab.',
  paymentDateTitle:
    'Wie lange dauert es, bis die Auszahlung eingeht, nachdem ich sie eingeleitet habe?',
  paymentDomain: 'Domänen-CNAME-Auflösung',
  paymentRatesTitle: 'Zahlung und Tarife für jedes Land',
  paymentServicesToParty:
    'Partei A stellt Zahlungsdienste für Partei B bereit und Partei B muss Partei A über die Anmeldeinformationen des Shops informieren. Partei A stellt Partei B außerdem relevante Transaktionsinformationen und Abfragedienste für Abrechnungsinformationen zur Verfügung, und Partei B muss mit Partei A zusammenarbeiten, um gemeinsam die Stabilität des Zahlungsproduktkontos aufrechtzuerhalten.',
  paymentSetting: 'Zahlungseinstellungen',
  paymentTime: 'Zahlungszeitpunkt',
  paymentaffiliations: 'Zahlungseinstellungen',
  paymentaffiliationsdesc:
    'Die Einstellungen zur Durchführung von Transaktionen in Ihrem Shop sowie die Sprach- und Ländereinstellungen für die Benutzeroberfläche, die den Kunden angezeigt wird',
  shopifyCurrencyConfirmBRL:
    'Bitte bestätigen Sie, dass die Währung Ihres Shopify-Shops auf BRL eingestellt ist.',
  shopifyCurrencyConfirmCLP:
    'Bitte bestätigen Sie, dass die Währung Ihres Shopify-Shops auf CLP eingestellt ist.',
  shopifyCurrencyConfirmCOP:
    'Bitte bestätigen Sie, dass die Währung Ihres Shopify-Shops auf COP eingestellt ist.',
  shopifyCurrencyConfirmEUR:
    'Bitte bestätigen Sie, dass die Währung Ihres Shopify-Shops auf EUR eingestellt ist.',
  shopifyCurrencyConfirmGBP:
    'Bitte bestätigen Sie, dass die Währung Ihres Shopify-Shops auf GBP eingestellt ist.',
  shopifyCurrencyConfirmUSD:
    'Please confirm that the currency in your Shopify store is set to USD.',
  shopifyCurrencyConfirmMXN:
    'Bitte bestätigen Sie, dass die Währung Ihres Shopify-Shops auf MXN eingestellt ist.',
  shopifyCurrencyConfirmPEN:
    'Bitte bestätigen Sie, dass die Währung Ihres Shopify-Shops auf PEN eingestellt ist.',
  shopifyCurrencyConfirmSEK:
    'Bitte bestätigen Sie, dass die Währung Ihres Shopify-Shops auf SEK eingestellt ist.',
  shopifyDomainUsedByOtherStore:
    'Diese Domain wurde bereits von einem anderen Shopify-Shop verwendet. Bitte ändern Sie den Status aller ungenutzten Shopify-Shops auf „Inactive“.',
  confirmStoreConnectedWiio:
    'Bitte bestätigen Sie, dass Ihr Shop mit Wiio Dropshipping verbunden ist.',
  confirmStoreConnectedUsaDrop:
    'Bitte bestätigen Sie, dass Ihr Shop mit USADrop Dropshipping verbunden ist.',
  paymentbtntext: 'Zum Einrichten',
  paymentdoamin: 'Domänen-CNAME-Auflösung',
  paymentlanguage: 'Sprache der Checkout-Seite',
  paymentoptions: 'Zahlungsmöglichkeiten',
  paymentoptionsdesc: 'Die in Ihrem Shop akzeptierten Zahlungsoptionen.',
  paymenttitle:
    'Konfigurieren Sie die in Ihrem Shop akzeptierten Zahlungsmethoden.',
  personalInformationVerification: 'Überprüfung persönlicher Daten',
  personalInformationVerificationSubTitle:
    'Bei der Informationsüberprüfung geht es um Ihre Mobiltelefonnummer.',
  phone: 'Telefonnummer',
  pixel: 'Pixel',
  pixelIDisRequired: 'Pixel-ID ist erforderlich',
  pixelTokenisRequired: 'Pixel-Token ist erforderlich',
  pixelexample:
    'Beispiel: Ein Kunde sieht Ihre Anzeige, besucht Ihre Website und tätigt einen Kauf. Pixel verfolgt dies und hilft Ihnen herauszufinden, welche Anzeigen die meisten Verkäufe generieren.',
  pixelhelp:
    'Analysieren Sie die Leistung Ihrer Marketingkampagnen und sehen Sie, wie Ihre Kunden mit Ihren Anzeigen und Ihrem Shop interagieren.',
  pixelid: 'Pixel lD',
  pixelname: 'Pixelname',
  pixeltoken: 'Pixel-Token',
  platforms: 'PLATTFORMEN',
  pleaseFillTheRequiredFields: 'Bitte füllen Sie die erforderlichen Felder aus',
  pleaseInput: 'Bitte eingeben',
  pleaseInputDomain: 'Bitte geben Sie die Domain ein',
  pleaseSelect: 'Bitte auswählen',
  pleaseSelectDate: 'Bitte wählen Sie ein Datum aus',
  pleconfirmPWD: 'Bitte bestätigen Sie das Passwort',
  pleinputPWD: 'Bitte geben Sie das Passwort ein',
  popup: 'Popup',
  popupBackground: 'Popup-Hintergrund',
  popupConfig: 'Popup-Konfiguration',
  popupConfigDesc: 'Popup-Anzeigeeffekt und Popup-Regeln',
  popupCycle: 'Pop-up-Zyklus',
  popupCycleItem: 'Erstmaliger Benutzer, Pop-up alle {input} Tage',
  preview: 'Vorschau',
  previousPage: 'Vorherige Seite',
  priceTerms: 'Preisbedingungen',
  privacypolicy: 'Datenschutzrichtlinie',
  processingTime:
    'Partei A wird alle Bestellungen aus dem Geschäft von Partei B ausführen und die Bearbeitungszeit, Versandzeit, Produktbeschreibungen im Geschäft von Partei B usw. entsprechend den Anforderungen von Partei A aktualisieren. Wenn es Anpassungsartikel gibt, wie z. B. nicht vorrätige Produkte und ähnliche Produkte, sollte Partei B die Anpassung/Entfernung innerhalb von 12 Stunden abschließen.',
  product: 'Produkt',
  productSpecifications:
    'Falsches Produkt, falsche Farbe, Größe, andere SPU, Spezifikationen, Rückerstattungen werden von Partei A getragen',
  productsImitation:
    'Nachgeahmte Produkte_Nachahmungsmarken, die Rückerstattung wird von Partei B getragen',
  propertyRights:
    'Das Hochladen und Verkaufen von Produkten, die geistige Eigentumsrechte verletzen, ist verboten',
  protocolBtnPrefix: 'Ich stimme dem zu',
  protocolBtnTitle: 'Zahlungsbedingungen und Datenschutzrichtlinie',
  protocolDialog: 'Benutzervereinbarung',
  questionsSupport:
    'Wenn Sie Fragen haben, nutzen Sie bitte unser unten aufgeführtes Supportmaterial:',
  recommendSize: 'Empfohlene Größe: {input}',
  recoverpassowrd: 'Passwort wiederherstellen',
  recovertitle: 'Geben Sie unten Ihre E-Mail-Adresse ein',
  rectifiedAccording:
    'Bei Rückerstattungen von Bestellungen, die nicht gemäß den Anforderungen von Partei A behoben wurden, geht die Rückerstattung zu Lasten von Partei B',
  redirectLink: 'Link umleiten',
  refundGuaranteeFees: 'Gebühren für die Rückerstattungsgarantie',
  refundGuaranteeTerms: 'Bedingungen der Rückerstattungsgarantie',
  refundShallBe:
    'Wenn das Produkt nicht überprüft wird und das Produkt nicht vorrätig ist, geht die Rückerstattung zu Lasten von Partei B',
  refundsAreBorne:
    'Aus den Logistikinformationen geht hervor, dass es längere Zeit nicht geliefert/aktualisiert wurde. Die Rückerstattung erfolgt zu Lasten von Partei A',
  refundsAreGiven:
    'Das Produkt wurde überprüft, das Produkt ist nicht vorrätig und der Kunde erhält eine Rückerstattung, die von Partei A getragen wird',
  register: 'Registrieren',
  registersuccess: 'Erfolg anmelden!',
  registertips:
    'Wir verwenden Ihre Daten, um Ihr Zugangskonto zu erstellen und Informationen zu senden, die Ihnen bei der Aktivierung Ihres Shops helfen.',
  requestNumber: 'BESTELLNUMMER',
  requests: 'Befehl',
  requestsCancellation:
    'Die Bestellung wurde nicht versandt und der Kunde beantragt eine Stornierung',
  save: 'Speichern',
  saveFields: 'Speichern Sie nach dem Ausfüllen der Felder Ihre Eingaben.',
  saveSuccessfully: 'Erfolgreich speichern',
  search: 'Suchen',
  secondarydomains: 'Sekundärdomänen',
  selectCountry: 'Wählen Sie Land aus',
  selectTimeZone: 'Wählen Sie Zeitzone',
  service: 'Service',
  serviceemail: 'Kundendienst-E-Mail',
  setUpDomain:
    'Richten Sie Ihre Domain bei Ihrem Anbieter ein, indem Sie die folgenden Schritte ausführen.',
  settings: 'Einstellungen',
  settlementPeriod:
    'Den Abrechnungszeitraum verlängern oder die Abrechnung aussetzen; Partei A hat das Recht, den Vertrag zu kündigen und ihn nicht an Partei B zurückzugeben. Der offene Betrag und die Anzahlung werden zu einem anderen vereinbarten Zeitpunkt nach sechs Monaten beglichen.',
  shipped:
    'Die Bestellzeit beträgt höchstens 3 Tage, die Bestellung wurde versandt und der Kunde beantragt eine Stornierung und Rückerstattung, wobei die Rückerstattung von Partei B getragen wird',
  shopify: 'Shopify',
  shopifybtntext: 'Installieren',
  shopifytitle: 'Installieren Sie Transparent Checkout in Ihrem Shopify-Shop.',
  skipshoppingcart: 'Warenkorb überspringen',
  specificRates: '3、Spezifische Tarife',
  specificUsageScenarios:
    'Rückerstattungen, die auf andere Weise generiert werden, werden von Partei A getragen. Für spezifische Nutzungsszenarien klicken Sie hier, um',
  sslCertificate: 'SSL-ZERTIFIKAT',
  start: 'Start',
  startDate: 'Startdatum',
  startUsing: 'Aktiv',
  startconfig: 'Beginnen Sie hier mit der Konfiguration',
  status: 'Status',
  step1Content:
    '„Gehen Sie zur Website Ihres Domain-Anbieters. Suchen Sie nach dem Abschnitt zur Konfiguration von DNS-Einträgen.“',
  step1Title: '„SCHRITT 1: ZUGRIFF AUF IHR ANBIETER-PANEL“',
  step2Content:
    'Fügen Sie bei Ihrem Anbieter im Abschnitt zur Konfiguration der DNS-Einträge die folgenden Informationen hinzu. Füllen Sie jedes Feld mit den unten aufgeführten entsprechenden Informationen aus:',
  step2Title: '„SCHRITT 2: ZUGRIFF AUF IHR ANBIETER-PANEL“',
  step3Content:
    'Nachdem Sie die oben genannten Einträge bei Ihrem Domain-Anbieter korrekt ausgefüllt haben, müssen Sie eine Weile warten, bis sich die Informationen verbreiten. Dieser Vorgang dauert in der Regel bis zu 4 Stunden.',
  step3Title: 'SCHRITT 3: WARTEN SIE AUF DIE VERBREITUNG',
  storeAccessingUrl: 'Adresse des Online-Shops',
  storeBinding: 'Shop verbinden',
  storeBindingSettings: 'Store-Einstellungen',
  storeLogo: 'Store-Logo',
  storeLogoLimitTips: 'Empfohlene Größe: 230*50, innerhalb von 200 KB',
  orderImage: 'Shop-Bestellvolumen - Letzte 30 Tage',
  orderRemark: 'Bestellhinweis',
  orderImageLimitTips: 'Mehrere Bilder werden unterstützt',
  viewOrderImageExample: 'Beispiel ansehen',
  storename: 'Shopname',
  termsofuse: 'Nutzungsbedingungen',
  theCheckoutPage:
    'Rabattbetrag/-prozentsatz: Legen Sie auf der Checkout-Seite einen festen Rabattbetrag/-prozentsatz fest, um Kunden dazu zu bewegen, diese Zahlungsmethode zu wählen.',
  theProductsSold:
    'Zu den auf der Website verkauften Produkten gehören Produkte, die nicht von der Marke autorisiert sind oder Marken verwenden, die nicht von der Marke autorisiert sind, sowie Produkte anderer Marken; Verletzung geistigen Eigentums, das nicht Markenrechte betrifft, einschließlich, aber nicht beschränkt auf: Filme, Videos, Lieder, Spiele, Animationswerke und deren Peripherieprodukte, einschließlich, aber nicht beschränkt auf Figuren, Zubehör und Charakterausrüstung.',
  theRefundShall:
    'Wenn der Kunde die Ware erhält und die Lieferzeit zu lang ist und die Ladenfrist nicht überschreitet, geht die Rückerstattung zu Lasten von Partei B',
  timezone: 'Zeitzone',
  tips: 'Tipps',
  toEmbedPaymentMethods: 'Zahlungsmethoden einbetten.',
  toenter: 'Eintreten',
  tosave: 'Zum Sparen',
  total: 'Gesamt',
  trackingNumber: 'Tracking-Nummer',
  transactionSettlement:
    'Partei B erklärt sich damit einverstanden, dass Partei A die oben genannten Gebühren vom Transaktionsabrechnungsbetrag von Partei B abzieht.',
  transferPlatform: 'Auftragsübertragungsplattform',
  tutorial: 'Anleitung',
  type: 'TYP:',
  typeofintegration: 'Art der Integration',
  typepassword: 'Geben Sie Ihr Passwort ein',
  unauthorized:
    'Bei nicht autorisierten Transaktionen geht die Rückerstattung zu Lasten von Partei B',
  unauthorizedTransaction: 'Nicht autorisierte Transaktion',
  unconvertedOrder: 'Nicht konvertierte Bestellung',
  update: 'Zum Aktualisieren',
  urlDisplayed:
    'Die URL, die im Webbrowser angezeigt wird, wenn Kunden Ihren Online-Shop durchsuchen, ist ein benutzerdefinierter Domainname.',
  usedNormally:
    'Kann nicht normal verwendet werden, Rückerstattungen werden von Partei A getragen',
  value: 'WERT:',
  wantsToCancel:
    'Der Kunde kauft mehr und möchte stornieren und eine Rückerstattung erhalten',
  whatisapixel: 'Was ist ein Pixel?',
  whatsAppTemplate: 'WhatsApp-Vorlage',
  whichTimeZoneSetTitle: 'Welche Zeitzone soll eingestellt werden?',
  withdrawalFeeAnswer:
    'Es hängt von Ihrer Bankgebühr ab. Verschiedene Banken haben unterschiedliche Gebühren.',
  withdrawalFeeTitle: 'Wie hoch sind die Gebühren für Abhebungen?',
  withdrawalMethodAnswer:
    'Nachdem Sie die Versandkosten bezahlt haben, können Sie das Wallet-Guthaben abheben. Banküberweisung und Paypal-Auszahlung werden unterstützt.',
  withdrawalMethodTitle:
    'Wie kann ich Bargeld abheben und welche Abhebungsmethoden gibt es?',
  yes: 'Ja',
  mismatched: 'Partei B',
  mustNotSell: 'dürfen keine Markenartikel verkaufen,',
  brandIconsMust:
    'und Markensymbole dürfen nicht in Produktbeschreibungen erscheinen. Sobald Partei A feststellt, dass es im Geschäft von Partei B ein illegales oder nicht übereinstimmendes Markenprodukt gibt, setzt Partei A innerhalb von 6 Stunden alle Zahlungen an das Geschäft von Partei B aus und stellt alle Auszahlungen ein. Partei A hat das Recht, Rückerstattungen für nicht konforme oder rechtswidrige Bestellungen zu veranlassen, und alle dadurch entstehenden Kosten und Ausgaben sind ausschließlich von Partei B zu tragen. Der konkrete Bußgeldbetrag ist in aufgeführt',
  theRefund: 'Der Rückerstattungsgarantieservice umfasst Folgendes:',
  refundGuarantee: 'Bedingungen der Rückerstattungsgarantie.',
  priceList: 'Preisliste',
  Holding: 'Halten',
  appendixTwo: 'Anhang 2.',
  paymentPriceList: 'Zahlungspreisliste',
  howDoes: 'Was ist Dropshipping und wie funktioniert es?',
  whatIsPayment: 'Was ist Wiio-Zahlung?',
  differenceDropshipping: 'Der Unterschied zwischen Nachnahme und Dropshipping',
  howsySterm: 'So verwenden Sie das Wiio-System',
  howShopifyAPI: 'So richten Sie die Shopify-API ein',
  howDomain: 'So richten Sie eine Domain ein',
  howPixel: 'So richtest du das Facebook-Pixel ein',
  howCoupon: 'So richten Sie einen Coupon ein',
  pleaseShopifyStore:
    'Bitte stellen Sie sicher, dass die Domain eine Verbindung zu Ihrem Shopify Store herstellt!',
  feeTerms: 'Gebührenbedingungen',
  noRefundGuarantee: 'Keine Rückerstattungsgarantiegebühr in Brasilien',
  deleteShopify:
    'So löschen oder fügen Sie die dynamische Schaltfläche „Jetzt kaufen“ und die Schaltfläche „In den Warenkorb“ in Shopify hinzu',
  stepOne:
    'Schritt 1: Navigieren Sie zu „Online-Shop“ → „Themen“ → „Anpassen“.',
  stepTwo:
    'Schritt 2 – Navigieren Sie zu „Produkte“ → „Standardprodukt“ → rufen Sie die Produktbeschreibungsseite auf',
  stepThree:
    'Schritt 3 – Klicken Sie auf „Schaltflächen kaufen“ → Klicken Sie, um „Dynamische Checkout-Schaltflächen anzeigen“ zu aktivieren → „Speichern“',
  dynamicCheckoutButton: 'So richten Sie den dynamischen Checkout-Button ein',
  personalInformationTitle: 'Meine Kontoinformationen',
  personalInformationSubTitle:
    'Bei der Überprüfung der Kontoinformationen handelt es sich um einen Prozess, der sicherstellt, dass Ihre Informationen korrekt und aktuell sind. Dazu gehört die Überprüfung Ihrer Telefonnummer, um sicherzustellen, dass sie korrekt und aktuell ist.',
  personalInformationTips: `Hinweis: 
Um die Authentizität Ihrer Identitätsinformationen sicherzustellen, müssen wir Ihre Mobiltelefonnummer überprüfen. Der Name und die Mobiltelefonnummer können nach der Überprüfung und Bindung nicht mehr geändert werden. Wenn Sie den Bestätigungscode nicht erhalten können oder ihn ändern müssen, wenden Sie sich bitte an den Wiio-Zahlungskundendienst/-agenten.`,
  contactName: 'Kontaktname',
  contactPhone: 'Telefonnummer',
  contactPhoneAreaCode: 'Telefonvorwahl',
  getVerificationCode: 'VERIFIZIERUNGSCODE ERHALTEN',
  verificationCode: 'Bestätigungscode',
  pleaseEnter: 'Bitte geben Sie {input} ein',
  pleaseSelect2: 'Bitte wählen Sie {input} aus',
  fulfillmentPlatform: 'Fulfillment-Plattform',
  pleaseEnterCorrect: 'Bitte geben Sie {input} richtig ein',
  sendSuccessfully: 'Erfolgreich senden',
  submitSuccessfully: 'Erfolgreich abschicken',
  serviceUnavailable: 'Der Dienst ist nicht verfügbar',
  loginExpired: 'Login abgelaufen, bitte loggen Sie sich erneut ein',
  toVerification: 'Zur Verifizierung',
  activeCustomerPaymentTips:
    'Die Überprüfung der persönlichen Daten ist noch nicht abgeschlossen, sodass der Zahlungsdienst nicht genutzt werden kann.',
  activeCustomerPaymentTips2:
    'Klicken Sie bitte auf „Überprüfung der persönlichen Daten“, um die Überprüfung der persönlichen Daten abzuschließen.',
  skipCartTips1:
    'Diese Funktion trägt dazu bei, die Conversion-Raten bei Einzelbestellungen zu erhöhen, aber die Add-to-Cart-Raten zu senken. Aktivieren Sie es nach Bedarf.',
  skipCartTips2: `Wenn die Wiio-Zahlung aktiviert ist, wird die Option „Zum Warenkorb hinzufügen“ von Shopify deaktiviert. 
Schaltfläche und behalten Sie nur die dynamischen Checkout-Schaltflächen bei. Kunden 
Wenn Sie auf diese Schaltflächen klicken, werden Sie direkt zur Kasse weitergeleitet 
Seite.`,
  skipCartTips3:
    '(Wenn die Checkout-Schaltfläche nach der Aktivierung dieser Funktion auf den Produktseiten nicht sichtbar ist, folgen Sie der Anleitung, um dynamische Checkout-Schaltflächen zu aktivieren:',
  advertisingMaterial: 'Tutorial zu Werbematerialien',
  violationRecord: 'Verstoßprotokoll',
  store: 'Speichern',
  state: 'Zustand',
  deadline: 'Frist',
  needModified: 'Muss geändert werden',
  reviewing: 'Überprüfung',
  completed: 'Vollendet',
  types: 'Typ',
  picture: 'Bild',
  details: 'Einzelheiten',
  overdue: 'Überfällig',
  rejected: 'Abgelehnt',
  operate: 'Arbeiten',
  complete: 'Vollständig',
  completeTips:
    'Wir sind dabei, es zur Überprüfung einzureichen. Bitte stellen Sie sicher, dass die Änderungen wie erforderlich durchgeführt wurden!',
  remark: 'Bemerkung',
  remarkPlaceholder: 'Bitte geben Sie einen Kommentar ein',
  pleaseInputRemark: 'Bitte füllen Sie den Kommentar aus',
  facebookPixel: 'Wie richte ich Facebook Pixel ein?',
  googlePixel: 'Wie richte ich Google Pixel ein?',
  themeColor: 'Themenfarbe',
  themeColorTips:
    'Mit dieser Einstellung können Sie die Designfarbe der „Checkout“-Oberfläche ändern.',
  buttonColor: 'Jetzt kaufen Farbe',
  buttonColorTips:
    'Mit dieser Einstellung können Sie die Farbe des „Jetzt kaufen“-Buttons ändern.',
  terminationAgreement: 'Vertragsbeendigung',
  installment: 'Rate',
  unhandledStores: 'Sie haben illegale Geschäfte',
  pixelTop1:
    'GTM ist bereits verlinkt. Sie können kein weiteres Pixel hinzufügen.',
  pixelTop2: 'Schalten Sie das aktuelle Pixel aus, bevor Sie GTM verwenden.',
  pixelTop3:
    'GTM und andere Pixel können nicht gleichzeitig funktionieren. Brauchen Sie Hilfe? Kontaktieren Sie Ihren Agenten.',
  successVideoTop: 'Echte Erfolgsgeschichten',
  paypalTop:
    'Bitte kontaktieren Sie unseren Agenten, um die Paypal-Zahlung zu aktivieren.',
  errorMessage: 'Es ist ein Serverfehler aufgetreten',
  wiioRechargeTitle: 'Erinnerung',
  wiioRechargeDesc:
    'Bitte zahlen Sie die monatliche Gebühr, um die Plattform zu nutzen.',
  wiilRechargeConfirm: 'Gehen Sie zur Wiio',
  orderPageDesigner: 'Checkout-Editor',
  export: 'Export',
  exporting: 'Exportieren...',
  unknownError: 'Unbekannter Fehler',
  downloadSuccess: 'Download erfolgreich',
  defaultExportNotice:
    'Standardmäßig werden Protokolle der letzten 30 Tage exportiert; Sie können einen maximalen Zeitraum von 30 Tagen auswählen',
  pageStyleConfig: 'Konfiguration des Seitenstils',
  reset: 'Zurücksetzen',
  limitedTimeOffer:
    'Zeitlich begrenztes Angebot! Bestellen Sie jetzt und profitieren Sie vom Rabatt!',
  countdownToEnd: 'Zeit bis zum Ende der Veranstaltung:',
  configLoadedSuccess: 'Konfigurationsdaten erfolgreich geladen',
  configLoadedUseDefault:
    'Konfigurationsdaten konnten nicht geladen werden, Standardwerte wurden verwendet',
  configLoadFailed:
    'Die Konfiguration konnte nicht abgerufen werden. Bitte überprüfen Sie das Netzwerk oder den Dienst',
  confirmRestore:
    'Sind Sie sicher, dass Sie die Konfiguration wiederherstellen möchten? Diese Aktion ist irreversibel',
  warning: 'Warnung',
  confirmReset: 'Bestätigen Sie das Zurücksetzen',
  submitSuccess: 'Erfolgreich übermittelt',
  checkoutConfigSaved:
    'Konfiguration der Checkout-Seite gespeichert und erfolgreich angewendet!',
  saveConfigFailed:
    'Die Konfiguration konnte nicht gespeichert werden. Bitte versuchen Sie es später noch einmal.',
  visualSizeConfig: 'Visuelle und Größenkonfiguration',
  width: 'Breite',
  height: 'Höhe',
  textAndCountdownConfig: 'Text- und Countdown-Konfiguration (Marketingtext)',
  textContent: 'Textinhalt',
  enterMarketingCopy: 'Bitte geben Sie eine Marketingkopie ein',
  fontSize: 'Schriftgröße',
  fontColor: 'Schriftfarbe',
  fontWeight: 'Schriftstärke',
  selectWeight: 'Gewicht auswählen',
  countdownSettings: 'Countdown-Einstellungen',
  enableCountdown: 'Countdown aktivieren',
  countdownPrefix: 'Countdown-Präfix',
  examplePrefix: 'Beispiel: Bis zum Ende',
  endTime: 'Endzeit',
  selectEndTime: 'Wählen Sie die Endzeit des Countdowns aus',
  textSpacing: 'Text-/Timer-Abstand',
  realtimePreview: 'Echtzeitvorschau',
  eventEnded: 'Die Veranstaltung ist beendet',
  rowInfo: 'Informationen zur Zeile {index}',
  icon: 'Symbol',
  title: 'Titel',
  bottomTextConfig: 'Untere Textkonfiguration',
  text: 'Text',
  suggestedSize: 'Empfohlene Größe',
  logo: 'Logo',
  banner: 'Banner',
  safetyInfo: 'Sicherheitsinformationen',
  securityIcons: 'Sicherheitssymbole',
  description: 'Beschreibung',
  confirmSavePageStyle:
    'Sind Sie sicher, dass Sie die aktuelle Seitenstilkonfiguration speichern möchten? Nach dem Speichern wird es sofort auf der Checkout-Seite wirksam.',
  getCodeTip:
    'Bitte füllen Sie zuerst Shop-Domain, API-Schlüssel und Geheimschlüssel aus.',
  getCode: 'Code abrufen',
  token_helper_tip:
    'Erhalten Sie das Zugriffstoken automatisch über die Dev-Dashboard-Anmeldeinformationen.',
  copySuccess: 'Kopiert!',
  paymentDetails: 'Zahlungsdetails',
  viewPaymentCode: 'Zahlungscode',
  paymentLink: 'Zahlungslink',
  paymentCodeDetails: 'Zahlungscode',
  barcode: 'Barcode',
  pixPaymentCode: 'PIX-Zahlungscode',
  copyPaymentCode: 'Zahlungscode kopieren',
  downloadPaymentImage: 'Bild herunterladen',
  paymentCodeValidUntil: 'Gültig bis',
  paymentImageUnavailable: 'Das Zahlungsbild konnte nicht erstellt werden.',
  copyFailed:
    'Kopieren fehlgeschlagen. Bitte wählen Sie den Code aus und kopieren Sie ihn manuell.',
  pleaseFillInClientIdAndSecret:
    'Bitte geben Sie die Client-ID (API-Schlüssel) und das Geheimnis (API-Geheimschlüssel) ein.',
  pleaseEnterClientIdAndSecret:
    'Bitte geben Sie die Client-ID (API-Schlüssel) und das Geheimnis (API-Geheimschlüssel) ein.',
  pleaseFillInClientIdAndSecretFirst:
    'Bitte geben Sie zuerst die Client-ID (API-Schlüssel) und das Geheimnis (API-Geheimschlüssel) ein',
  pleaseContactAgent: 'Bitte kontaktieren Sie den Agenten',
  createStoreMexicoWiioPaymentsTitle:
    'Bauen Sie Ihren Shopify-Shop von Grund auf auf',
  couponDisplayConfig: 'Coupon-Anzeige',
  displayMode: 'Anzeigemodus',
  couponDisplayExpand: 'Expandieren',
  couponDisplayHide: 'Verstecken',
  couponHideModeTipStart:
    'Wenn diese Option aktiviert ist, ist das Gutscheineingabefeld standardmäßig ausgeblendet. Wenn Sie einen',
  couponHideModeTipEnd:
    'konfiguriert haben und er aktiv ist, wird er automatisch angewendet, wenn ein Kunde eine zweite Bestellung aufgibt. Wenn Kunden keine Rabattcodes verwenden sollen, setzen Sie den Gutscheinstatus bitte auf "Deaktiviert".',
  couponDisplayCollapse: 'Zusammenbruch',
  couponUnselected: 'Nicht ausgewählt',
  couponNoAvailable: 'Keine verfügbaren Gutscheine',
  couponNoCode: 'Muss nicht ausgefüllt werden',
  productPrice: 'Produkt',
  productDiscount: 'Rabatt',
  productShipping: 'Versand',
  free: 'Frei',
  apply: 'Anwenden',
  orderPreviewPriceProduct: '9999,00 $',
  orderPreviewPriceDiscount: '-0,00 $',
  orderPreviewPriceTotal: '9999,00 $',
  uponTransactionRisks:
    'Nachdem der Verbraucher einen Rückerstattungsantrag gestellt hat, behält sich Partei A das Recht vor, eine Rückerstattung für die Transaktion durchzuführen, um schwerwiegendere Transaktionsrisiken zu mindern.',
  howGooglePixel: 'So richtest du das Google Pixel ein',
  fulfillmentPlatformTips: 'Wichtig: Bestellungen, die über unsere Zahlungslösung bezahlt werden, müssen über unseren Fulfillment-Service abgewickelt werden.'
}
